import moment from 'moment';
import strings from 'strings';

const { resendTime: resendTimeCopies } = strings.bulkEmails.forms.fields;
const getBulkTypeArrayTrueValue = arr => (arr?.length > 0 ? arr : null);
const scheduleDateInboundAccesor = ({ sendDate }) => (sendDate ? moment(sendDate) : null);
const getResendTitle = numberOfDays =>
  strings.formatString(resendTimeCopies.optionTitle, { numberOfDays });

export const BulkBlockOptions = {
  intervals: [
    { id: '10,days', title: getResendTitle(10) },
    { id: '15,days', title: getResendTitle(15) },
    { id: '30,days', title: getResendTitle(30) }
  ],
  resend: [
    { id: 'true', title: 'On' },
    { id: 'false', title: 'Off' }
  ]
};

export const BulkDrawerFormFieldsMap = {
  AIPromptId: {
    key: 'promptId'
  },
  AllowMarketingCandidates: {
    key: 'allowMarketingCandidates',
    inboundAccesor: 'emailConfig.marketing.allowMarketingCandidates'
  },
  AllowRecruitHirings: {
    key: 'allowRecruitHirings',
    inboundAccesor: 'emailConfig.recruiting.allowRecruitHirings'
  },
  Attempts: {
    key: 'attempts'
  },
  BlockAssociatedCompanies: {
    key: 'blockAssociatedCompanies',
    inboundAccesor: 'emailConfig.marketing.blockAssociatedCompanies'
  },
  BlockCompanies: {
    key: 'blockCompanies',
    inboundAccesor: 'emailConfig.marketing.blockCompanies'
  },
  BlockResend: {
    key: 'blockResend',
    inboundAccesor: ({ emailConfig }) => String(emailConfig?.blockResend)
  },
  BlockSigned: {
    key: 'blockSigned',
    inboundAccesor: 'emailConfig.marketing.blockClientCompanies'
  },
  BulkQuota: {
    key: 'bulkQuota'
  },
  BulkScope: {
    key: 'bulkScope',
    inboundAccesor: 'emailConfig.bulkType'
  },
  EmailBody: {
    key: 'emailBody',
    inboundAccesor: 'emailBody.html'
  },
  GeneralBulkCategory: {
    key: 'generalBulkCategory',
    inboundAccesor: 'emailConfig.generalCategory'
  },
  JobOrderRecruitment: {
    key: 'jobOrderRecruitment',
    inboundAccesor: ({ emailConfig }) =>
      getBulkTypeArrayTrueValue(emailConfig?.recruiting.recruitingJobOrders)
  },
  MarketCandidates: {
    key: 'marketCandidates',
    inboundAccesor: ({ emailConfig }) =>
      getBulkTypeArrayTrueValue(emailConfig?.marketing.marketingCandidates)
  },
  RemovedAttachments: {
    key: 'removedAttachments'
  },
  ResendTime: {
    key: 'resendTime',
    inboundAccesor: ({ emailConfig }) =>
      BulkBlockOptions.intervals.find(interval => interval.id === `${emailConfig?.blockDays},days`)
  },
  ScheduleDate: {
    key: 'scheduleDate',
    inboundAccesor: scheduleDateInboundAccesor
  },
  ScheduleTime: {
    key: 'scheduleTime',
    inboundAccesor: scheduleDateInboundAccesor
  },
  SendViaOutlook: {
    key: 'sendViaOutlook',
    inboundAccesor: 'emailConfig.sendViaOutlook'
  },
  SmartTags: {
    key: 'smartTags'
  },
  Subject: {
    key: 'subject',
    inboundAccesor: 'emailBody.subject'
  },
  Template: {
    key: 'template',
    inboundAccesor: ({ emailConfig }) => ({
      id: emailConfig?.template.id,
      name: emailConfig?.template.name
    })
  },
  To: {
    key: 'to',
    paramKey: 'searchProject'
  }
};

export const scheduleKeys = [
  BulkDrawerFormFieldsMap.ScheduleDate.key,
  BulkDrawerFormFieldsMap.ScheduleTime.key
];
